<script lang="ts">
    import { intToVisual } from 'hydria/utils/numbers'


    

    
    interface Props {
        value?: string | number | null;
        forceNeg?: boolean;
        zeroIsNeg?: boolean;
        // If not null, displayed when 0
        zeroString?: any;
        // If true, null is seen as 0
        nullIsZero?: boolean;
        nullValue?: string;
    }

    let {
        value = null,
        forceNeg = false,
        zeroIsNeg = false,
        zeroString = null,
        nullIsZero = true,
        nullValue = ''
    }: Props = $props();

    let displayValue = $derived(value == null && !nullIsZero ? nullValue : intToVisual(value == null ? 0 : value, forceNeg, zeroIsNeg, zeroString))
</script>

<span class="int-currency">{displayValue}</span>
